export default __webpack_public_path__ + "static/media/tutorial_5.91e88440.svg";